<template src="./templates/index.html" />

<script type="text/ecmascript-6">
import FouContainer from 'src/components/tools/fou-container/'
import FouGrid from 'src/components/layout/fou-grid/'
import Misc from 'src/utils/helper/misc'
import { ScrollPagination } from 'src/utils/helper/scroll'
import { mapActions, mapGetters } from 'vuex'
import CommonMethods from 'src/pages/home/script/common.methods'
import AnimationProcessing from 'components/animations/processing'
import FouSpan from 'src/components/general/fou-span/'
export default {
  name: 'FsFoundryApplications',

  components: {
    FouContainer,
    ...FouGrid,
    AnimationProcessing,
    FouSpan
  },

  data() {
    return {
      scrollPagination: ScrollPagination(),
      searchKeyword: null,
      searchStateValue: null,
      pageNumber: 1,
      loadActive: false,
      scrollEnd: false,
      prdScore: '',
      status: [
        { name: 'all', query: null, countLabel: 'all' },
        { name: 'new', query: 'in_review', countLabel: 'new' },
        { name: 'accepted', query: 'approved', countLabel: 'approved' },
        { name: 'completed', query: 'exists', countLabel: 'exists' },
        { name: 'rejected', query: 'rejected', countLabel: 'rejected' }
      ],
      setStatus: null
    }
  },

  methods: {
    ...mapActions('signUp', ['getApplications']),
    ...Misc,
    ...CommonMethods,
    resetParams() {
      this.pageNumber = 1
      this.setStatus = 'in_review'
      this.searchKeyword = null
    },
    getApplicationsByStatus(query = null) {
      return new Promise((resolve, reject) => {
        this.setStatus = query
        this.pageNumber = 1
        this.loadPageStart()
        this.$store.commit('signUp/emptyApplications')
        this
          .getApplications({
            searchKeyword: this.searchKeyword,
            status: this.setStatus,
            page: this.pageNumber
          })
          .then(result => {
            this.loadApplications(result)
            this.loadPageComplete(result)
            resolve()
          })
          .catch(() => {
            this.loadActive = false
            resolve()
          })
      })
    },
    loadApplications(results) {
      this.$nextTick(() => {
        this.processPagination('applications-list', results, this.loadNextPage)
      })
    },
    loadNextPage() {
      return new Promise(resolve => {
        this.loadPageStart()
        this.pageNumber++
        this
          .getApplications({
            searchKeyword: this.searchKeyword,
            status: this.setStatus,
            page: this.pageNumber
          })
          .then(result => {
            this.loadPageComplete(result)
            resolve()
          })
          .catch(() => {
            this.loadActive = false
            resolve()
          })
      })
    },
    loadPageComplete(result) {
      const len = result.collection.length
      if (len > 0 && len === this.queries.perPage) {
        this.scrollPagination.idle()
      }
      if (len > 0) {
        this.scrollEnd = false
      }
      this.loadActive = false
    },
    filterClass(query) {
      const f = this.setStatus
      return 'mt-tag' + (f === query ? '' : ' mt-tag--pure-hover')
    },
    sortApplications(sortBy) {
      if (this.queries.sortBy === sortBy) {
        this.queries.sortDirection = this.queries.sortDirection === 'desc'
          ? 'asc'
          : 'desc'
      } else {
        this.queries.sortBy = sortBy
        this.queries.sortDirection = 'desc'
      }
      this.getApplicationsByStatus(this.setStatus)
    },
    sortStyle(sortby) {
      return [
        { [this.$style.sortActive]: this.queries.sortBy === sortby },
        { [this.$style.sortActiveDesc]: this.queries.sortBy === sortby && this.queries.sortDirection === 'desc' },
        { [this.$style.sortActiveAsc]: this.queries.sortBy === sortby && this.queries.sortDirection === 'asc' }
      ]
    },
    searchClear() {
      this.searchKeyword = null
      this.search()
    },
    search() {
      this.searchKeyword = this.searchKeyword !== null ? this.searchKeyword.trim() : this.searchKeyword
      this.getApplicationsByStatus(this.setStatus)
      this.searchStateValue = this.searchKeyword
    }
  },
  computed: {
    ...mapGetters('auth', ['user', 'hasRole']),
    ...mapGetters('signUp', {
      applications: 'applicationsList',
      queries: 'queries',
      count: ['applicationsCount']
    })
  },
  created() {
    window.scrollTo(0, 0)
    this.resetParams()
    this.getApplicationsByStatus(this.setStatus)
  },
  beforeUnmount() {
    this.scrollPagination.remove()
    this.resetParams()
    this.$store.commit('signUp/emptyApplications')
  }
}
</script>

<style src="./stylesheets/index.scss" lang="scss" module></style>